import garageCustomizationReducer from "./garageCustomization";

export { garageCustomizationActions } from "./garageCustomization";

export default garageCustomizationReducer;
